<template>
  <div class="m-width">
    <div class="w-100">
      <div class="item-bg-div position-relative radio-masthead-content">
        <!-- <div
          class="owl-carousel owl-theme carousel-position"
          id="radiomasthead"
        >
          <div
            class="item position-relative"
            v-for="item_radio in radio"
            :key="item_radio.id"
          >
            <div
              class="details-wrapper w-100 d-flex justify-content-center align-items-center flex-column"
            >
              <div class="item-img-wrapper">
                <img
                  v-bind:src="getRadioImgForMasthead(item_radio.id)"
                  @error="imageLoadError($event)"
                />
              </div>
              <div>
                <p
                  class="item-desc mb-0"
                  v-html="
                    item_radio.data.description.replace(
                      /(?:\r\n|\r|\n|\n\n)/g,
                      '<br />'
                    )
                  "
                ></p>
              </div>
            </div>
          </div>
        </div> -->
        <div class="playerAbsoluteDiv ">
          <div class="playerWrapper d-flex flex-column">
            <div class="playerAbsolute">
              <RadioPlayer :id="playerID" :type="'audio'" />
            </div>
          </div>
        </div>
        <div class="live-icon-wrapper">
          <div class="custom-icon">
            <img src="@/assets/icon/icon-live.svg" class="btn-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import RadioPlayer from "@/components/players/radioPlayer.vue";
export default {
  data: function() {
    return {
      radio: [],
      playerID: 0,
    };
  },
  props: ["active_id"],
  components: {
    RadioPlayer,
  },
  methods: {
    filterRadio() {
      var vm = this;
      var radio_order = vm.active_id;

      var data = vm.$store.state.radio.data;
      // SORT BY ORDER (ID) FIRST
      var radio_order = [4, 7, 6, 3, 5];
      data.sort(function(a, b) {
        return radio_order.indexOf(a.id) - radio_order.indexOf(b.id);
      });

      const index = data.findIndex((e) => e.id == vm.active_id);
      data.unshift(data.splice(index, 1)[0]);

      vm.radio = data;

      var store = [];
      vm.radio.forEach((item) => {
        item["img_link"] = vm.mastheadImgFiltering(item);
        store.push(item);
      });

      vm.radio = store;

      Vue.nextTick(
        function() {
          vm.generateRadioMastheadOwlCarousel("#radiomasthead");
        }.bind(vm)
      );

      Vue.nextTick(
        function() {
          vm.playerID = vm.active_id;
        }.bind(vm)
      );
    },
    imageLoadError(event) {
      event.target.src = noimage;
    },
    generateRadioMastheadOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        center: true,
        responsiveClass: true,
        margin: 0,
        stagePadding: 0,
        navText: [
          '<div class="border-nav"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
          '<div class="border-nav"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            margin: 0,
            nav: false,
          },
          768: {
            nav: false,
          },
        },
      });
    },
  },
  created: function() {
    this.$store.dispatch("fetchRadio", { self: this });
  },
  mounted() {},
};
</script>

<style scoped>
.playerWrapper {
  height: 420px;
  position: relative;
  width: 100%;
  max-width: 380px;
  overflow: hidden;
}
.playerAbsoluteDiv {
  position: absolute;
  top: 30%;
  left: 70%;
  transform: translate(-50%, -50%);
  width: 380px;
  z-index: 15;
}
.playerAbsolute {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 380px;
  z-index: 16;
}
.live-icon-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  height: 56px;
}
.custom-icon {
  width: 100%;
  height: 56px;
}
.custom-icon img {
  height: 100%;
}
.m-width {
  max-width: 1600px;
  margin: 0 auto;
  overflow-x: hidden;
}
.ml-header {
  margin-left: 10%;
}

.text-white {
  color: #e6e6e6;
}
.text-yellow {
  color: #facb43;
}
.details-wrapper {
  margin-bottom: 40px;
}
.item-bg-div {
  background: linear-gradient(
      218deg,
      rgba(241, 196, 36, 0.85) 8%,
      rgba(241, 196, 36, 0.5) 20%,
      rgba(0, 0, 0, 0) 60%
    ),
    url("../../../assets/radio/radio-bg.png");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: top left;
  background-repeat: no-repeat;
  padding-top: calc(430 / 1585 * 100%);
  width: 100%;
  height: 430px;
  z-index: 1;
}
.carousel-position {
  position: absolute;
  bottom: 20%;
  right: 5%;
  max-width: 600px;
}
.carousel-position:before {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  filter: blur(45px);
  width: 350px;
  height: 205px;
  border-radius: 40%;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
.carousel-position .item {
  cursor: pointer;
  position: relative;
  max-width: 100%;
  z-index: -1;
}

.item-img-wrapper {
  max-width: 480px;
  position: relative;
  width: 100%;
}

.item-title {
  font-size: 23px;
  font-weight: bold;
  line-height: 1.14;
  color: #ffffff;
}

.item-desc {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #000000;
  font-family: "Poppins", sans-serif !important;
}
@media screen and (max-width: 768px) {
  .item-bg-div {
    height: 400px;
  }
  .carousel-position {
    max-width: 100%;
    right: unset;
  }

  .playerAbsoluteDiv {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
<style>
.radio-masthead-content .owl-theme .owl-dots {
  position: absolute;
  bottom: -20%;
  left: 50%;
  transform: translateX(-50%);
}
.radio-masthead-content .owl-theme .owl-dots .owl-dot span {
  width: 22px;
  height: 5px;
  margin: 5px;
  background: #869791;
}
.radio-masthead-content .owl-theme .owl-dots .owl-dot.active span,
.radio-masthead-content .owl-theme .owl-dots .owl-dot:hover span {
  background: #fab92b;
}
.radio-masthead-content .owl-theme .owl-prev,
.radio-masthead-content .owl-theme .owl-next {
  position: absolute;
  color: inherit;
  background: rgba(0, 0, 0, 0);
  border: none;
  z-index: 100;
  top: 50%;
  transform: translateY(-50%);
  border-radius: none;
  width: 100px;
  outline: none;
}
.radio-masthead-content .owl-theme .owl-prev .border-nav,
.radio-masthead-content .owl-theme .owl-next .border-nav {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.radio-masthead-content .owl-theme .owl-prev .border-nav i {
  font-size: 2rem;
  color: #fab900;
  padding: 0 6px 0 4px;
}
.radio-masthead-content .owl-theme .owl-next .border-nav i {
  font-size: 2rem;
  color: #fab900;
  padding: 0 4px 0 8px;
}
.radio-masthead-content .owl-theme .owl-prev {
  left: 0;
  display: flex;
  justify-content: center;
}
.radio-masthead-content .owl-theme .owl-next {
  right: 0;
  display: flex;
  justify-content: center;
}
.radio-masthead-content .owl-theme .owl-nav [class*="owl-"]:hover {
  background: unset !important;
}

@media screen and (max-width: 768px) {
  .radio-masthead-content .owl-theme .owl-dots {
    bottom: -30%;
  }
  .radio-masthead-content .owl-theme .owl-dots .owl-dot span {
    width: 16px;
    height: 3px;
    margin: 3px;
  }
}
</style>
